// extracted by mini-css-extract-plugin
module.exports = {"collapseHover":"QAsection_collapseHover__NtJR0"};